module.exports = __webpack_public_path__ + "static/michael-hill-love-174ce2341928882a51a2e938923e0bb5.png";